module.exports = __webpack_public_path__ + "img/mastercard.38e107fd.webp";